module.exports = require("json-rules-engine");